import { Component, OnInit } from '@angular/core';
import { Service } from 'src/app/service';
import { Advisor } from 'src/app/advisor';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  advisor: Advisor;
  isShown: boolean = false;
  activatedRoute: any;

  constructor(
    public quiz: Service,
    public router: Router,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
  }


  startAssessment() {
      this.router.navigate(['/home', 'question', '0']);
  }
  

}